module.exports = __webpack_public_path__ + "img/PO.842e9a52.svg";